<template>
  <div class="row container-fluid my-4 p-2 justify-content-center">
    <div class="col-md-6">
      <div class="search-form">
        <input type="text" placeholder="Rechercher un article" 
        class="search-input" 
        @keyup.enter="onSearch"
        v-model="sT"
        >
      <div class="search-icon" @click="onSearch">
        <i class="fas fa-search"></i>
      </div>
      </div>
     
    </div>
  </div>
</template>

<script>
export default {
  name: "MainSearchBar",
  data() {
    return {
      shopName: "shop",
      serverParams: {
          searchTerm: null,
          sort: {
            field: "reference",
            type: "asc"
          },
          page: 1,
          sfamille: '0',
          perPage: 108
        }
    }
  },
  methods: {
     goToShop(){
      if (this.$router.currentRoute.name === this.shopName && ( this.$route.query.search && (this.$route.query.search === this.sT))) {
         return
      }

      this.$router.push({path: '/'+this.shopName, query:{search: this.sT}})
         
    },
    onSearch: function(){
      this.$store.dispatch('utils/updateSearch', {searchTerm: this.sT})
        this.goToShop();
      
    },
},
computed: {
  sT: {
          get () {
              return this.$store.getters['utils/searchTerm'];
              
          },

          set (value) {
            this.$store.dispatch('utils/updateSearch', { searchTerm: value })
          }
        },
}
}
</script>

<style scoped>
  .search-form {
    position: relative;
    width: 100%;
  }

  .search-input {
    width: 100%;
    padding: .5rem 1rem;
    height: 50px;
    font-size: 1rem;
    font-weight: bold;
    border: 1px solid rgb(150, 127, 52);
    border-radius: 5px;
  }

  .search-input:focus {
    /* outline: none; */
    border-color: rgb(150, 127, 52);
  }

  .search-icon {
   position: absolute;
   top: 15px;
   right: 20px;
   font-size: 1.5rem;
   color: rgb(150, 127, 52);
   cursor: pointer;
  }
</style>
